module.exports = __webpack_public_path__ + "img/esn.333cf305.svg";